export default __webpack_public_path__ + "ef3b08708030af41e380ebb7823a1f1b.png";